var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [
        _vm._v(" Alert Type: " + _vm._s(_vm.alert.alert_title) + " ")
      ]),
      _c(
        "gg-card-text",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c("v-simple-table", {
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function fn() {
                          return [
                            _c("thead", [
                              _c("tr", [
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-left"
                                  },
                                  [_vm._v(" Affected Service ")]
                                ),
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-left"
                                  },
                                  [_vm._v(" Alert Threshold ")]
                                ),
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-left"
                                  },
                                  [_vm._v(" Current Usage ")]
                                ),
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-left"
                                  },
                                  [_vm._v(" Description ")]
                                ),
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-left"
                                  },
                                  [_vm._v(" Status ")]
                                ),
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-left"
                                  },
                                  [_vm._v(" Created ")]
                                ),
                                _c(
                                  "th",
                                  {
                                    staticClass: "text-left"
                                  },
                                  [_vm._v(" Last Notified ")]
                                )
                              ])
                            ]),
                            _c("tbody", [
                              _c("tr", [
                                _c("td", [
                                  _c("div", [
                                    _vm._v(
                                      " " + _vm._s(_vm.alert.service) + " "
                                    )
                                  ]),
                                  _vm.alert.subaccount_username
                                    ? _c("div", [
                                        _vm._v(
                                          " cPanel Username: " +
                                            _vm._s(
                                              _vm.alert.subaccount_username
                                            ) +
                                            ". "
                                        )
                                      ])
                                    : _vm._e()
                                ]),
                                _c("td", [
                                  _vm._v(_vm._s(_vm.alert.alertThreshold))
                                ]),
                                _c("td", [
                                  _vm._v(_vm._s(_vm.alert.currentUsage))
                                ]),
                                _c(
                                  "td",
                                  {
                                    staticStyle: {
                                      "white-space": "normal"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.alert.alert_description))]
                                ),
                                _c(
                                  "td",
                                  {
                                    staticClass: "text-capitalize"
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mb-1",
                                        attrs: {
                                          small: "",
                                          color: _vm.statusColor(
                                            _vm.alert.status
                                          )
                                        }
                                      },
                                      [_vm._v(" mdi-circle ")]
                                    ),
                                    _vm._v(" " + _vm._s(_vm.alert.status) + " ")
                                  ],
                                  1
                                ),
                                _c("td", [
                                  _vm._v(_vm._s(_vm.alert.created_at))
                                ]),
                                _c("td", [
                                  _vm._v(_vm._s(_vm.alert.last_notified_at))
                                ])
                              ])
                            ])
                          ]
                        },
                        proxy: true
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }